import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import * as language from './modules/language';
import * as merchant from './modules/merchant';

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    language,
    merchant
  },

  plugins: [createPersistedState()]
})

/* eslint-disable */
if (module.hot) {
  module.hot.accept(['./modules/language', './modules/merchant'], () => {
    const newLanguageModule = require('./modules/language');
    const newMerchantModule = require('./modules/merchant');

    store.hotUpdate({
      modules: {
        language: newLanguageModule,
        merchant: newMerchantModule
      }
    })
  });
}
/* eslint-enable */

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js